import { getPaymentStatus } from '../../../services/billingPayments';
import { TThunkAction } from '../../../../common/types/thunk';
import { EPaymentProvider } from '../../../../PaymentWidgetMicrofrontend';
import { EPaymentStatus, EPaymentType } from '../../../types/reducers/paymentProcessing';
import { processPaymentStatusThunk } from '../processPaymentStatus';
import { setPaymentProcessingStatus } from '../../../actions/paymentProcessing';
import { sleep } from '../../../../common/utils/sleep';
import { selectConfigValue } from '../../../selectors/config';

interface IParams {
  type: EPaymentType;
  provider: EPaymentProvider;
  paymentId: string;
}

export const checkPaymentStatusThunk =
  (params: IParams): TThunkAction<Promise<EPaymentStatus>> =>
  async (dispatch, getState, { httpApi }) => {
    const { type, paymentId, provider } = params;

    const state = getState();
    const timeout = selectConfigValue('checkPaymentStatusTimeout')(state);
    const interval = selectConfigValue('checkPaymentStatusInterval')(state);
    let isTimeoutReached = false;

    dispatch(setPaymentProcessingStatus({ type, status: EPaymentStatus.Pending }));

    const circuitBreaker = async () => {
      await sleep(timeout);

      isTimeoutReached = true;

      return EPaymentStatus.Canceled;
    };

    const checkStatus = async (): Promise<EPaymentStatus> => {
      const status = await getPaymentStatus({ httpApi, paymentId, provider });

      if (status === EPaymentStatus.Pending) {
        await sleep(interval);

        if (isTimeoutReached) {
          return EPaymentStatus.Canceled;
        }

        return checkStatus();
      }

      return status;
    };

    const status = await Promise.race([circuitBreaker(), checkStatus()]);

    dispatch(processPaymentStatusThunk({ type, status }));

    return status;
  };
